import React, {useCallback, useEffect, useState} from "react";
import { makeStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import {connect} from "react-redux";
import Grid from "@material-ui/core/Grid";
import Divider from '@material-ui/core/Divider';
import InfoCard from "../StudyRequestInfo/InfoCard";
import StateInfoField from "../StudyRequestInfo/StateInfoField";
import {format, parseISO} from "date-fns";
import ru from "date-fns/locale/ru";
import PersonOutlineOutlinedIcon from "@material-ui/icons/PersonOutlineOutlined";
import {createRequestStudent, setStudent} from "../../../api";
import {
  getRelationStudentList,
  getRequestMainInfo,
  getRequestSystemInfo
} from "../../../store/actions";
import CreateNewPersonModal from "./CreateNewPersonModal";
import {logError, logSuccess} from "../../../store/message";
import RelationStudentsTable from "../RequestRelations/RelationStudentsTable";

const useStyles = makeStyles(() => ({
  root: {
    paddingLeft: 8,
    width: 774,
    "& .MuiFormLabel-root": {
      whiteSpace: "nowrap"
    },
    "& .MuiInputBase-input.Mui-disabled": {
      color: "#000"
    }
  },
  progress: {
    display: "flex",
    justifyContent: "center"
  },
  heading: {
    fontSize: 14,
    lineHeight: "18px",
    display: "flex",
    alignItems: "center",
    color: "#000000",
    margin: "8px 0"
  },
  block: {
    margin: "0 0 32px 0"
  }
}));

const formatDate = date =>
  date ? format(parseISO(date), "dd.MM.yyyy", { locale: ru }) : null;

const StudentRelation = ({                            requestId,
                           targetAudience,
                           relatedStudent,
                           schoolchild,
                           schoolchildParent,
                           student,
                           status,
                           getRelationStudentList,
                           relStudentList,
                          isFetchingWorkProcess,
                           person,
                           studentSnils
}) => {
  const [newPersonModalOpen, setNewPersonModalOpen] = useState(false);
  const [isCreatingStudent, setIsCreatingStudent] = useState(false);
  const classes = useStyles();

  useEffect(() => {
    if (requestId) {
      getRelationStudentList(requestId);
    }
  }, [requestId]);

  const createStudentChain = useCallback((form) => {
    setIsCreatingStudent(true);
    return createRequestStudent(form).then(response => {
      if (response.status === 200) {
        let resp = response.data;
        if (resp.success) {
          let pid = resp.id;
          return setStudent(requestId, pid).then(response => {
            if (response.status === 200) {
              getRequestSystemInfo(requestId);
              getRequestMainInfo(requestId);
              logSuccess("Пользователь успешно создан в системе.");
            } else {
              return Promise.reject(response);
            }
            setNewPersonModalOpen(false);
            setIsCreatingStudent(false);
            return Promise.resolve();
          }).catch(err => {
            if (err.response && err.response.status === 400) {
              let message = err.response;
              if (err.response.data && err.response.data.errors) {
                message = err.response.data.errors.map(({message}) => message).join(", ");
              }
              logError(message);
            } else {
              logError(err);
            }
          })
        }
      } else {
        return Promise.reject(response);
      }
      setIsCreatingStudent(false);
      setNewPersonModalOpen(false);
      return Promise.resolve();
    }, (err) => {
      if (err.response && err.response.status === 400) {
        let message = err.response;
        if (err.response.data && err.response.data.errors) {
          message = err.response.data.errors.map(({message}) => message).join(", ");
        }
        logError(message);
      } else {
        logError(err);
      }
      setIsCreatingStudent(false);
    }).catch(err => {
      if (err.response && err.response.status === 400) {
        let message = err.response;
        if (err.response.data && err.response.data.errors) {
          message = err.response.data.errors.map(({message}) => message).join(", ");
        }
        logError(message);
      } else {
        logError(err);
      }
      setIsCreatingStudent(false);
    })
  },[]);


  const cardActions = [
    {
      label: "СОЗДАТЬ НОВОГО",
      disabled: false,
      onClick: () => setNewPersonModalOpen(true)
    }
  ];

  return (
    <div className={classes.root}>
      <CreateNewPersonModal
        open={newPersonModalOpen}
        handleClose={() => setNewPersonModalOpen(false)}
        createStudent={createStudentChain}
        isCreatingStudent={isCreatingStudent}
        requestData={{
          lastName:(targetAudience === "schoolchild") ? (schoolchild.lastName || "") : (student.lastName || ""),
          firstName:(targetAudience === "schoolchild") ? (schoolchild.firstName || "") : (student.firstName || ""),
          middleName:(targetAudience === "schoolchild") ? (schoolchild.middleName || "") : (student.middleName || ""),
          birthday:(targetAudience === "schoolchild") ? (schoolchild.birthDate || "") : (student.birthDate || ""),
          snils:studentSnils,
          phone:(targetAudience === "schoolchild") ? (schoolchildParent.phone || "") : (student.phone || ""),
          email:(targetAudience === "schoolchild") ? (schoolchildParent.email || "") : (student.email || ""),
        }}
      />
      <div className={classes.block}>
          <Typography className={classes.heading}>
            {`Обучающийся ${targetAudience === "schoolchild" ? '(школьник)' : ''}`}
          </Typography>
          <Grid container spacing={1}>
            <Grid item xs={12} sm={6}>
              <StateInfoField field="ФИО" value={(targetAudience === "schoolchild") ? (schoolchild && schoolchild.name ? schoolchild.name : "-") : (student && student.name ? student.name : "-")}/>
              <StateInfoField field="Дата рождения" value={(targetAudience === "schoolchild") ? (schoolchild.birthDate ? formatDate(schoolchild.birthDate) : "-") : (student && student.birthDate ? formatDate(student.birthDate) : "-")}/>
              <StateInfoField field="СНИЛС" value={studentSnils || '-'}/>
              {(schoolchild && (targetAudience === "schoolchild")) ?
              <>
                <StateInfoField field="Школа" value={schoolchild.school || '-'}/>
                <StateInfoField field="Класс" value={schoolchild.class || '-'}/>
                <StateInfoField field="Смена" value={schoolchild.shift}/>
                <StateInfoField field="Первая бесплатная профессия" value={schoolchild.gotFreeProfession ? "Получена" : "Нет"}/>
              </> :
                <>
                <StateInfoField field="Телефон" value={student.phone || '-'}/>
                <StateInfoField field="E-mail" value={student.email || '-'}/>
                </>
              }
            </Grid>
            <Grid item xs={12} sm={6}>
              <InfoCard title="Учётная запись в системе"
                        icon={<PersonOutlineOutlinedIcon/>}
                        disabled={targetAudience !== "schoolchild"}
                        contentTitle={relatedStudent ? relatedStudent.name : "не зарегестрирован"}
                        subheader={relatedStudent !== null ? "зарегистрирован" : "отсутствует"}
                        contentBody={relatedStudent ? <>
                          <StateInfoField field="Дата рождения" value={relatedStudent.birthday ? formatDate(relatedStudent.birthday) : '-'}/>
                          <StateInfoField field="Email" value={relatedStudent.email || '-'}/>
                          <StateInfoField field="Телефон" value={relatedStudent.phone || '-'}/>
                          <StateInfoField field="СНИЛС" value={relatedStudent.snils || '-'}/>
                        </> : <></>}
                        loading={isFetchingWorkProcess}
                        cardActions={!relatedStudent ? cardActions : null}
              />
            </Grid>
          </Grid>
        </div>
      <br/>
      <Divider/>
      <br/>

      {(targetAudience === "schoolchild" && schoolchildParent) &&
      <div className={classes.block}>
        <Typography className={classes.heading}>Законный представитель школьника</Typography>
        <Grid container spacing={1}>
          <Grid item xs={12} sm={6}>
            <StateInfoField field="ФИО" value={schoolchildParent.name}/>
            <StateInfoField field="Телефон" value={schoolchildParent.phone || '-'}/>
            <StateInfoField field="E-mail" value={schoolchildParent.email || '-'}/>
          </Grid>
          <Grid item xs={12} sm={6}>
            <InfoCard title="Учётная запись в системе"
                      icon={<PersonOutlineOutlinedIcon/>}
                      contentTitle={person ? person.name : "не зарегистрирован"}
                      subheader={person !== null ? "зарегистрирован" : "отсутствует"}
                      contentBody={person && <>
                        <StateInfoField field="Дата рождения" value={person.birthday ? formatDate(person.birthday) : '-'}/>
                        <StateInfoField field="Email" value={person.email || '-'}/>
                        <StateInfoField field="Телефон" value={person.phone || '-'}/>
                        <StateInfoField field="СНИЛС" value={person.snils || '-'}/>
                        <StateInfoField field="Подано заявок" value={person.requestCount || '-'}/>
                      </>}
                      loading={isFetchingWorkProcess}/>
          </Grid>
        </Grid>
      </div>}

      <br/>
      <Divider/>
      <br/>

      <div className={classes.block}>
        <Typography className={classes.heading}>
          Совпадения среди обучающихся
          {(relStudentList && relStudentList.length > 0) ?
            ` (найдено совпадений: ${relStudentList.length})`
            : ' (совпадений не найдено)'
          }
        </Typography>
        {(relStudentList && relStudentList.length > 0) &&
        <RelationStudentsTable relStudentList={relStudentList}
                               requestId={requestId}/>
        }
      </div>
    </div>
  )
};

const mapStateToProps = state => ({
  isFetchingWorkProcess: state.studyRequests.isFetchingWorkProcess,
  relStudentList: state.studyRequests.relStudentList
});

const mapDispatchToProps = dispatch => ({
  getRelationStudentList: (id) => dispatch(getRelationStudentList(id))
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(StudentRelation)
